import moment from 'moment';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/produitConf';
import genererModeReglement from './genererModeReglement';
import genererDelaiReglement from './genererDelaiReglement';
import genererDelaiReglementDetail from './genererDelaiReglementDetail';

export default function genererDevisCommande(societe, agenceId, commercialId) {
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  const categorieVente = produitConf.CATEGORIE_UNITAIRE;
  return {
    type: devisConf.TYPE_DEVIS,
    echeanciers: [],
    sousType: devisConf.NORMAL,
    dateDevisCommande: moment().format('YYYY-MM-DD'),
    dateValidite: moment().format('YYYY-MM-DD'),
    commercialId: commercialId,
    assistantId: null,
    theme: '',
    id: null,
    commentaireInterne: null,
    commentaire: null,
    intervenants: [],
    lignesCommande: [],
    penalite: true,
    escompte: true,
    recouvrement: true,
    montantHt: 0,
    montantTva: 0,
    montantTtc: 0,
    companyId: 1,
    factureGroupee: true,
    repartitionsTva: [],
    echeancierPaiement: [],
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    categorieVente,
    renouvelable: false,
    reconductible: false,
    dateRenouvellement: null,
    adresseLivraison: societe ? societe.adresseLivraison : null,
    masqueRemise: false,
    agenceId: agenceId,
    societeId: societe.id,
    role: 'MandatairePayeur',
    afficherPanneauxSousContrat: true,
  };
}
